'use strict';

var _ = require('lodash');
var GridToolbarConfigurationFlightAssignmentController = function GridToolbarConfigurationFlightAssignmentController($scope, toolbarGridService) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = selectedRows.length === 1;
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  function setStructureWithOldValues(loadedData, rowid) {
    loadedData[rowid]._old = {};
    var columns = $scope.jqxGridSettings.columns;
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  $scope.add = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({
      isNewlyAdded: true
    });
    setStructureWithOldValues(loadedData, 0);
    $scope.updateData(loadedData);
  };
  $scope.remove = function () {
    var rows = $scope.jqxGridSettings.source._source.localdata;
    $scope.$emit('configuration-assignment-grid:remove', $scope.selectedRows, rows);
    toolbarGridService.removeRow($scope);
  };
  $scope.duplicate = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndex = $scope.jqxGridSettings.jqxGrid('getselectedrowindex');
    var rowid = $scope.jqxGridSettings.jqxGrid('getrowid', selectedIndex);
    var oldRow = loadedData[rowid];
    var newRow = _.clone(oldRow);
    delete newRow.hepKey;
    loadedData.splice(rowid, 0, newRow);
    setStructureWithOldValues(loadedData, rowid);
    $scope.updateData(loadedData);
  };
  $scope.saveChanges = function () {
    var rows = _.chain($scope.jqxGridSettings.source.loadedData).filter('_old').map(function (row) {
      delete row.isNewlyAdded;
      return row;
    }).cloneDeep().value(true);
    $scope.$emit('configuration-assignment-grid:saveChanges', rows);
  };
  $scope.$on('configuration-assignment-grid:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
};
GridToolbarConfigurationFlightAssignmentController.$inject = ['$scope', 'ToolbarGridService'];
module.exports = GridToolbarConfigurationFlightAssignmentController;